import { type ProductInterface } from "@jti/fe-common";

type Item = {
  role?: string[];
  url: string;
  label: string | null;
};

export default function getUrlByRole(data: ProductInterface): string | undefined {
  if (!data || data.length === 0) {
    return undefined;
  }

  const dynamicBundleItem = data.find((item: Item) => item.role?.includes("dynamic_picture_bundle"));

  if (dynamicBundleItem) {
    return dynamicBundleItem.url;
  }

  const thumbnailItem = data.find((item: Item) => item.role?.includes("thumbnail"));

  if (thumbnailItem) {
    return thumbnailItem.url;
  }

  return data[0].url || undefined;
}
